export const replaceParams = <T extends Record<string, unknown>>(
	url: string,
	record: T,
): string => {
	return url?.replace(/:([A-Za-z0-9_]+)/g, (_, key: string) => {
		const value = record[key as keyof T];

		if (value === undefined || value === null) return '';
		return encodeURIComponent(String(value));
	});
};
